import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { style: {"display":"flex","gap":"8px","align-items":"center"} }
const _hoisted_4 = { class: "toolbar" }
const _hoisted_5 = { class: "seg" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "cl-date" }
const _hoisted_8 = { class: "cl-mon" }
const _hoisted_9 = { class: "cl-day" }
const _hoisted_10 = { class: "cl-yr" }
const _hoisted_11 = { style: {"flex":"1"} }
const _hoisted_12 = { class: "cl-nm" }
const _hoisted_13 = { class: "cl-sub" }
const _hoisted_14 = { class: "cl-right" }
const _hoisted_15 = {
  key: 0,
  style: {"font-size":"12.5px"}
}
const _hoisted_16 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_17 = { class: "form-wrapper slide-up" }
const _hoisted_18 = { class: "form-close" }
const _hoisted_19 = { class: "tr-toggle" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "primary" }
const _hoisted_22 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_23 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 2,
  style: {"margin":"20px 0 0","font-size":"14px"}
}
const _hoisted_26 = {
  key: 3,
  style: {"margin":"20px 0 0","font-size":"14px"}
}
const _hoisted_27 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_page_button = _resolveComponent("forge-page-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
        _createElementVNode("div", { class: "page-bar-main" }, "Training")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_forge_page_button, {
          kinds: ['training'],
          label: "Plan my session",
          onApplied: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadItems()))
        }),
        (_ctx.$store.state.user.teamHubRole == 'Admin' || _ctx.$store.state.user.teamHubEmployee?.IsManager)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddEditFn())),
              class: "add-btn"
            }, "Plan session"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => { _ctx.completed = false; _ctx.loadItems() }, ["prevent"])),
            class: _normalizeClass(_ctx.completed ? '' : 'on')
          }, "Upcoming", 2),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => { _ctx.completed = true; _ctx.loadItems() }, ["prevent"])),
            class: _normalizeClass(_ctx.completed ? 'on' : '')
          }, "Completed", 2)
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "spacer" }, null, -1))
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("div", { style: {"margin":"20px 0 20px"} }, [
        _createTextVNode("Plan a "),
        _createElementVNode("b", null, "classroom"),
        _createTextVNode(" session (group review with a timer) or an "),
        _createElementVNode("b", null, "on-site"),
        _createTextVNode(" session (hands-on at the station, signed off per person). When it's time to run it, choose who's involved.")
      ], -1)),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classrooms, (c, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            onClick: () => { _ctx.$router.push('/classroom/'+c.ID) },
            class: "cl-card"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(c.month), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(c.date), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(c.year), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(c.Name) + " ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass('tr-type ' + (c.Type == 'On-site' ? 'onsite' : 'classroom'))
                }, [
                  _createVNode(_component_svg_icon, {
                    icon: c.Type == 'On-site' ? 'wrench' : 'classroom'
                  }, null, 8, ["icon"]),
                  _createTextVNode(_toDisplayString(c.Type == 'On-site' ? 'On-site' : 'Classroom'), 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(c.subLine), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (c.timeString)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(c.timeString), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass('pill ' + c.pill)
              }, [
                _createVNode(_component_svg_icon, {
                  icon: c.pillIcon
                }, null, 8, ["icon"]),
                _createTextVNode(_toDisplayString(c.Status), 1)
              ], 2),
              _createVNode(_component_svg_icon, {
                style: {"width":"10px","height":"10px"},
                icon: "chevright"
              })
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ], 2),
    (_ctx.showAddEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[4] || (_cache[4] = () => { _ctx.showAddEdit = false })
              }, "×")
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Type", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass('tr-toggle-btn' + (_ctx.formData.Type == 'Classroom' ? ' on' : '')),
                onClick: _cache[5] || (_cache[5] = () => { _ctx.formData.Type = 'Classroom' })
              }, [
                _createVNode(_component_svg_icon, { icon: "classroom" }),
                _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "ttb-t" }, "Classroom"),
                  _createElementVNode("div", { class: "ttb-d" }, "Group review with a timer")
                ], -1))
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass('tr-toggle-btn' + (_ctx.formData.Type == 'On-site' ? ' on' : '')),
                onClick: _cache[6] || (_cache[6] = () => { _ctx.formData.Type = 'On-site' })
              }, [
                _createVNode(_component_svg_icon, { icon: "wrench" }),
                _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "ttb-t" }, "On-site"),
                  _createElementVNode("div", { class: "ttb-d" }, "Hands-on, signed off per person")
                ], -1))
              ], 2)
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("h3", { style: {"margin-top":"15px"} }, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _ctx.formData.Type == 'On-site' ? 'e.g. Expander Line 2 -- Hands-On' : 'e.g. New Hire Onboarding -- Production',
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.Name) = $event))
            }, null, 8, _hoisted_20), [
              [_vModelText, _ctx.formData.Name]
            ]),
            (_ctx.formData.Type == 'On-site')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Station / Location", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "e.g. Expander Line 2 · Cincinnati",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.Station) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.formData.Station]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Date", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.Date) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.Date]
            ]),
            (_ctx.formData.Type == 'On-site')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[21] || (_cache[21] = _createElementVNode("h3", null, "What We're Reviewing", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Short description of what you'll cover at the station",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.ReviewingText) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.formData.ReviewingText]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("h3", null, [
              _createTextVNode(_toDisplayString(_ctx.formData.Type == 'On-site' ? 'Related Processes' : 'Processes to Review') + " ", 1),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formData.ProcessesJSON.length), 1),
              _cache[22] || (_cache[22] = _createTextVNode()),
              (_ctx.formData.Type == 'On-site')
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "· optional"))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.processSearchQ) = $event)),
              onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterProcesses())),
              placeholder: "Search processes"
            }, null, 544), [
              [_vModelText, _ctx.processSearchQ]
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (p, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  style: {"margin-bottom":"5px"},
                  class: "checkbox-input"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((p.checked) = $event),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setProcessesJSON()))
                  }, null, 40, _hoisted_24), [
                    [_vModelCheckbox, p.checked]
                  ]),
                  _createElementVNode("div", null, _toDisplayString(p.Name), 1)
                ]))
              }), 128))
            ]),
            (_ctx.formData.Type == 'On-site')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_svg_icon, {
                    icon: "ibubble2",
                    style: {"width":"14px","height":"14px"}
                  }),
                  _cache[23] || (_cache[23] = _createTextVNode("Trainees are picked at the station and signed off one by one.", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_svg_icon, {
                    icon: "ibubble2",
                    style: {"width":"14px","height":"14px"}
                  }),
                  _cache[24] || (_cache[24] = _createTextVNode("Attendees are chosen when you start the session, so you can take whoever is actually in the room.", -1))
                ])),
            _createElementVNode("input", {
              style: {"margin-top":"25px"},
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: _ctx.formData.Type == 'On-site' ? 'Create On-site Session' : 'Create Classroom',
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitAddEdit()))
            }, null, 10, _hoisted_27)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}